// l10n status: done
import { Button, Divider, Menu, MenuItem, ListItemIcon, IconButton } from "@mui/material"
import { LightTooltip } from "components/LightTooltip"
import { CreateComponent } from "components/utils/CreateComponent"
import { useEffect, useState, useRef } from "react"
import { rootStore } from "store/RootStore"
import ListIcon from "components/welcomeModal/icons/channel-list.svg"
import { observable, makeObservable, action, flow } from "mobx"
import { appFeatures } from "AppFeatures"
import classnames from "classnames"

//import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import ArrowDown from "img/arrow-down.svg"
import CheckIcon from 'img/icons/check-white.svg';
import AddIcon from 'img/icons/add-white.svg';
import EditIcon from 'img/icons/edit-white.svg';
import { ROUTE_NAMES } from "site-ql/RouteConst"
//import { PROGRAM_ORIGIN } from "scenes/components/EpgChannelDetailsInfo"
import { useNavigateRouteAdd } from "components/utils/RouteUtils"
import { EventEmitter } from "components/utils/EventEmitter"
import { isMobileScreenSize } from "utils/Utils"
//import { ModalMessage } from "components/ModalMessage"
import { ConfirmationDialog } from "components/ConfirmationDialog"
import { ButtonGeneric } from "scenes/components/ButtonComponents"
import { l10n } from "store/lang/L10n"
import { timeNow } from "utils/Utils"
import { ChannelListType } from "@quickline/coco"
import { analyticsScreen, analyticsMeta } from "store/qlapi/LogService"


import "./css/channelListMenu.css"

const styles = theme => ({
	NavBarArrowIcon: { padding: 0, marginTop: "-4px" },
	ChannelListMenuList: {
		//padding: "5px 0 10px",
		zIndex: 1500,
		borderRadius: "4px",
		boxShadow: "0 8px 10px 1px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2)",
		outline: "0 solid",
		background: "#3F3F3F !important",
		overflowY: "auto"
	},
	ChannelListMenuListItem: {
		display: "flex",
		justifyContent: "flex-start",
		fontSize: "20px",
		padding: "4px 16px",
		//minWidth: "300px",
		height: "2.5rem",
	},
	Icons: {
		paddingRight: "10px", marginTop: "0px"
	},

	ChannelListSelected: { background: "rgba(0,0,0,0.08)" },
	EditIconEnabled: { opacity: 1.0, cursor: "default", pointerEvent: "none", borderRadius: "100%" },
	CheckIconContainer: { minWidth: "40px" },
	MenuColumn: { display: "flex", flex: "1 1 auto", justifyContent: "flex-start" },
	//ChannelListMenuButton: { margin: "1px 5px 1px 0px !important" }
	// MTVW-1044: 1 line with ellipsis for mobile
	ChannelListLabel: { display: '-webkit-inline-box', WebkitBoxOrient: "vertical", cursor: "pointer", WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }
})

// MTVW-33
class ChannelListInfo {
	id = null
	name = l10n.featureChannelListsAllSenders

	constructor() {
		console.debug("%s ChannelListInfo constructor", timeNow())
		makeObservable(this, {
			id: observable,
			name: observable,
			setId: action,
			setName: action
		})
	}

	setId(id, origin, from) {
		console.debug("%s ChannelListInfo setId %s, origin %s, from %s", timeNow(), id, origin, from)
		this.id = id
	}

	setName(name, origin, from) {
		console.debug("%s ChannelListInfo setName %s, origin %s, from %s", timeNow(), name, origin, from)
		this.name = name
	}
}

const channelListInfo = new ChannelListInfo()
let cbRegistered = false

export const ChannelListMenu = CreateComponent(styles, false, true, ({ classes, origin }) => {
	// const anchorEl = useRef(null)
	const [anchorEl, setAnchorEl] = useState(null)
	//const open = Boolean(anchorEl)
	const refChannelLists = useRef(rootStore.channelsService.channelLists)
	//const [open, setOpen] = useState(false)
	const allChannels = { id: "allChannelsListId", name: l10n.featureChannelListsAllSenders }
	const isMobile = isMobileScreenSize()
	const myProfiledId = rootStore?.sso?.profile?.id

	const cbSubscribe = (event) => {
		//function cbSubscribe(event) {
		//console.debug("reloadChannelLists event %o", event)
		setTimeout(() => {
			reloadChannelLists(event)
		}, 150)
		/*
		setTimeout(() => {
			reloadChannelLists(event)
		}, 500)
		*/
	}

	useEffect(() => {
		console.debug("%s useEffect %s, %o", timeNow(), origin, channelListInfo)
		//EventEmitter.release("reloadChannelLists", cbSubscribe)

		// event "reloadChannelLists" is generated in ChannelListEditor
		/*if (!cbRegistered)*/ EventEmitter.subscribe("reloadChannelLists", cbSubscribe)
		cbRegistered = true
		// MTVW-920: limit number of calls, channelsMS generates "unsubscribed" channels if multiple simulaneous requests are issued
		// defer until loading at startup should be done
		// MTVW-1098: 300ms settling time
		setTimeout(() => {
			reloadChannelLists("")
			// strange behavior on Android, only in TvGuide and not in LiveTv
		}, 300)

		/*
		EventEmitter.subscribe("activeChannelListDeleted", (event) => {
			console.debug("event is: %o", event)
			handleChangeChannelList(allChannels, false)
		})
		*/
		return (() => {
			EventEmitter.release("reloadChannelLists", cbSubscribe)
			console.debug("%s ~useEffect %s %o", timeNow(), origin, channelListInfo)
		})
	}, [])

	const reloadChannelLists = flow(function* (event) {
		// MTVW-33
		let channelListId = rootStore.sso.browserStore.getChannelListId()
		console.debug("reloadChannelLists", channelListId, rootStore.sso.browserStore.currentProfileId, rootStore.sso?.profile.id)
		if (!channelListId) channelListId = allChannels.id
		let chId = allChannels.id
		let chName = allChannels.name
		try {
			// channelList is updated upon a change in the ChannelListEditor
			if (event === "deleted") {
				handleChangeChannelList(allChannels, false)
				return
			}
			const chLists = yield rootStore.channelsService.getChannelListsAsync(true)
			if (chLists) {
				console.debug("%s chLists %s %o %o", timeNow(), origin, chLists, channelListId)
				for (let elem of chLists) {
					//console.debug("elem", elem.Channels.Channel.length, elem.name, elem.id, channelListId)
					// MTVW-33
					if (elem.id === channelListId) {
						//console.debug("HIT %s ", elem.name)
						chName = elem.name
						chId = elem.id
						break
					}
				}
				channelListInfo.setId(chId, origin, "reloadChannelLists")
				channelListInfo.setName(chName, origin, "reloadChannelLists")
				if (rootStore.channelsService.indexInChannelList(rootStore.channelsService.activeChannelId) < 0) {
					rootStore.channelsService.setActiveChannel(rootStore.channelsService.getFirstChannelListChannel)
				}
				rootStore.channelsService.setActiveChannelListId(chId)
				refChannelLists.current = chLists
			}
		}
		catch (e) {
			console.error("CAUGHT in reloadChannelLists", e)
		}
		//console.trace("reloadChannelLists done")
	})

	const handleToggle = (e) => {
		e.preventDefault()
		// MTV-3583: e.stopPropagation required with React 17
		//e.stopPropagation()
		//console.debug("handleToggle", e)
		e?.nativeEvent?.stopImmediatePropagation()
		setAnchorEl(e?.currentTarget ?? null)
		//setOpen(e?.currentTarget ? true : false)
		if (e?.currentTarget) {
			// refresh channel lists
			// MTVW-636: useEffect will be called
			//reloadChannelLists("")
		}
	}

	const handleClose = (e = null, reason = "") => {
		if (e !== null /*&& reason !== ""*/) {
			//e.preventDefault()
			e.stopPropagation()
		}
		console.debug("%s handleClose %s %o reason %s", timeNow(), origin, e, reason)
		setAnchorEl(null)
		//setOpen(false)
		// on mobile, a touch event on the close button would also create a 2nd event on the Senderliste button that would invoke handleToggle
	}

	const handleChangeChannelList = (channelList, doClose = true) => {
		// Return to avoid interference on Android menus between LiveTv and TvGuide
		//navigateRouteAdd(origin === PROGRAM_ORIGIN.liveTv ? ROUTE_NAMES.LiveTv : ROUTE_NAMES.TvGuide)
		if (!anchorEl) return
		if (channelListInfo.id === channelList.id) {
			handleClose()
			return
		}
		//console.debug("New list: %o, %s", channelList, channelList.id)
		console.debug("%s handleChangeChannelList entry %s %s", timeNow(), origin, channelList.name)
		channelListInfo.setId(channelList.id, origin, "handleChangeChannelList")
		channelListInfo.setName(channelList.name, origin, "handleChangeChannelList")
		// MTVW-33
		rootStore.sso.browserStore.setChannelList(channelList.id, channelList.name)

		// MTVW-1013
		rootStore.channelsService.getChannelListAsync(channelList.id).then((res) => {
			rootStore.channelsService.setActiveChannel(rootStore.channelsService.getFirstChannelListChannel)
			// MTVW-1029: handleChangeChannel only in LiveTv!
			if (rootStore.page.Player.isInLiveTv) rootStore.page.Player.handleChangeChannel(rootStore.channelsService.activeChannelId)
		})
		console.debug("%s handleChangeChannelList %s %o %o", timeNow(), origin, doClose, channelListInfo)
		rootStore.channelsService.setActiveChannelListId(channelList.id)

		console.debug("%s handleChangeChannelList before handleClose %s, %s", timeNow(), origin, doClose)
		if (doClose) handleClose()
	}

	// MTVW-657: error if more than 20 channel lists per profile
	const DisabledMessage = {
		show: false, info: {}, onCancel: null, onConfirm: null
	}
	const [modalMessage, setModalMessage] = useState(DisabledMessage)

	const navigateRouteAdd = useNavigateRouteAdd()

	const confirmError = (modalMessage) => {
		setModalMessage(modalMessage => ({ ...modalMessage, show: false }))
	}
	const TooManyChannelListsMessage = {
		show: true,
		info: {
			title: l10n.featureChannelListsTooManyChannelListsTitle,
			content: l10n.featureChannelListsTooManyChannelListsDescription,
			button1: null,
			button2: l10n.commonActionOk
		},
		onCancel: null, onConfirm: confirmError
	}

	const handleCreateChannelList = () => {
		// MTVW-657: check number of channel lists created by the current profile
		const MAX_LISTS = 20
		let nOwnLists = 0
		for (let i = 0; i < refChannelLists.current.length; i++) {
			// MTVW-1074: with CoCo channel lists type has to be checked
			// MTVW-1056: use ChannelListType for typed endpoint
			//if (refChannelLists.current[i].ProfileId === rootStore.sso.profile?.id) nOwnLists++
			if (refChannelLists.current[i].type === ChannelListType.UserDefined) nOwnLists++
		}
		//console.debug("channelLists=", channelLists, channelLists?.length, nOwnLists)
		if (nOwnLists >= MAX_LISTS) {
			handleClose()
			setModalMessage(TooManyChannelListsMessage)
		}
		else {
			navigateRouteAdd(ROUTE_NAMES.ChannelListEditor, { type: "create", id: null })
			handleClose()
		}
	}

	const handleEditChannelList = (channelList) => {
		navigateRouteAdd(ROUTE_NAMES.ChannelListEditor, { type: "edit", id: channelList.id })
		handleClose()
	}

	// MTVW-955
	if (anchorEl) rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.channelListSelector })
	// MTVW-636: observe channelLists
	return refChannelLists.current && (
		<div>
			{modalMessage.show &&
				<ConfirmationDialog
					title={modalMessage.info.title}
					onCloseHandler={() => {
						if (modalMessage.onConfirm) modalMessage.onConfirm(modalMessage)
					}}
					data-test="modal_message"
					bottomButtons={
						[{
							bType: ButtonGeneric,
							props: {
								bId: `buttonConfirm`, variant: "primary",
								label: l10n.commonActionOk,
								onClick: function () {
									if (modalMessage.onConfirm) modalMessage.onConfirm(modalMessage)
								},
								dataTest: "modal_message_confirm_button"
							}
						}
						]}
				>
					{modalMessage.info.content}
				</ConfirmationDialog>
			}
			{/* <LightTooltip title="Senderlisten" > */}
			<Button
				id="channelListMenuButton"
				data-test="channel_menu_current"
				aria-controls={anchorEl ? 'customized-menu' : undefined}
				disableRipple={true}
				aria-haspopup="true"
				aria-expanded={anchorEl ? 'true' : undefined}
				onClick={(e) => {
					handleToggle(e)
				 }}
			>
				<img src={ListIcon} className={classes.Icons} alt="Sender" />
				{/* MTVW-1078 TEMPORARY PATCH: replace "Alle Sender" returned from CoCo with translated l10n.featureChannelListsAllSenders
					<label className={classes.ChannelListLabel} data-test="active_channel_list_name">{channelListInfo.name}</label>
				*/}
				<label className={classes.ChannelListLabel} data-test="active_channel_list_name">{channelListInfo.name === "Alle Sender" ? l10n.featureChannelListsAllSenders : channelListInfo.name}</label>
				<img src={ArrowDown} className={classes.NavBarArrowIcon} alt=""></img>
				{/* <KeyboardArrowDownIcon className={classes.NavBarArrowIcon} /> */}
			</Button>
			{/* </LightTooltip> */}

			<Menu
				//ref={anchorEl}
				id="customized-menu"
				aria-labelledby="customized-menu"
				//getContentAnchorEl={null}
				elevation={2}
				/* moved to slotProps
				classes={{
					paper: `${classes.ChannelListMenuList} PopperItemResponsive`
				}}
				*/
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center"
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center"
				}}

				// MTVW-1022: avoid phantom clicks on menu items 
				keepMounted={false}	// avoid phantom clicks
				anchorEl={anchorEl}
				open={anchorEl !== null}
				onClose={handleClose}
				onClick={handleClose}
				data-test="list_channelList"
				// MTVW:1044: enable portal so that the channel list menu is shown over the bottom menu bar for mobile
				disablePortal={false}
				slotProps={{
					paper: {
						classes: {
							root: `${classes.ChannelListMenuList} PopperItemResponsive`
						},
						style: {
							scrollbarWidth: "none",
							maxHeight: "auto",
							overflowY: "auto",
						},
					}
				}}
			>
				<MenuItem key={"change_" + origin} onClick={(e) => {
					e.preventDefault()
					e.stopPropagation()
					handleChangeChannelList(allChannels)
				}}
					className={classnames(classes.ChannelListMenuListItem, { [classes.ChannelListSelected]: channelListInfo?.id === null })}
					data-test="channel_menu_item">
					{channelListInfo?.name === allChannels.name ?
						<ListItemIcon className={classes.CheckIconContainer}>
							<img src={CheckIcon} alt="check icon" />
						</ListItemIcon>
						:
						<div className={classes.CheckIconContainer}></div>
					}
					{allChannels.name}
				</MenuItem>

				{/* MTVW-1013: start mapping at 2nd element */}
				{refChannelLists.current?.slice(1).map((i, ix) => (
					<div key={i.id + origin}>
						{/* MTVW-657: divider before first predefined channel list*/}
						<div>
							{i.firstPredefined ?
								<Divider />
								: null
							}
						</div>
						{/* MTVW-1002: added below condition */}
						{/*(i.ProfileId === myProfiledId || i.ProfileId === "predefined")*/ true &&
							<MenuItem //key={i.id}
								onClick={(e) => {
									e.preventDefault()
									e.stopPropagation()
									handleChangeChannelList(i)
								}}
								className={classnames(classes.ChannelListMenuListItem, { [classes.ChannelListSelected]: channelListInfo?.id === i.id })}
							>
								<div className={classes.MenuColumn}>
									{/*console.debug("chlist= %s, personal %s, profileId %s, isOwner %s", i.name, i.IsPersonal, i.ProfileId, i.ProfileId === myProfiledId)*/}
									{channelListInfo?.id === i.id ?
										<ListItemIcon className={classes.CheckIconContainer}>
											<img src={CheckIcon} alt="check icon" />
										</ListItemIcon>
										:
										<div className={classes.CheckIconContainer}></div>
									}
									{i.name}
								</div>
								<IconButton style={{ visibility: (/*i.ProfileId === rootStore.sso.profile?.id*/ (i.type === ChannelListType.UserDefined)) && !isMobile ? "visible" : "hidden" }} className={classes.EditIconEnabled} data-test="channel_menu_edit" onClick={(e) => {
									handleEditChannelList(i)
									e.stopPropagation() // for not change the channelList
								}}>
									<img src={EditIcon} alt="edit icon" />
								</IconButton>
							</MenuItem>
						}
					</div>
				))}
				{/* MTVW-121 hide the menu item to open the channelList editor on mobile devices */}
				{!isMobile &&
					<div>
						<Divider />
						<LightTooltip
							// MTVW-121 title={!isMobile ? "Neue Senderliste erstellen." : "Nur auf Tablet und Desktop verfügbar"} arrow]
							title={l10n.featureChannelListsCreateNewList}
							placement={"left"}
						>
							<span>
								<MenuItem key={"create_" + origin} onClick={handleCreateChannelList}
									className={classes.ChannelListMenuListItem}
								// MTVW-121 disabled={isMobile}
								>
									<ListItemIcon className={classes.CheckIconContainer}>
										<img src={AddIcon} alt="add icon" />
									</ListItemIcon>
									{l10n.featureChannelListsNewList}
								</MenuItem>
							</span>
						</LightTooltip>
					</div>}
			</Menu>
		</div>
	)
})
